/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ChatMessageRequestBodyDoc } from './chatMessageRequestBodyDoc';

/**
 * ``POST /inbox/chats/{chat_id}/messages`` body.
 *
 * LinkedIn DMs are plain text on the wire but the composer still
 * speaks TipTap (so AI prompt / variable / snippet extensions
 * work). The send activity flattens ``body_doc`` to plain text
 * and length-checks against 8000 chars (spec §6.4).
 */
export interface ChatMessageRequest {
  body_doc: ChatMessageRequestBodyDoc;
  scheduled_send_at?: string | null;
  timezone?: string | null;
  send_as_inmail?: boolean;
  /**
     * @minLength 8
     * @maxLength 128
     */
  idempotency_key: string;
}
